import styled from 'styled-components'

import BootstrapModalHeader from 'react-bootstrap/lib/ModalHeader'

export const ModalHeader = styled(BootstrapModalHeader)`
  padding: 40px;
  border: none;
`



// WEBPACK FOOTER //
// ./src/Components/Modal/ModalHeader/index.js